/*
 * ```
 *
 *  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *     .       .       .       .       .       .       .       .       .       .       .       .
 *       . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *   .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *     . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *    .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *       8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *    . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *       8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *    . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *       @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *    .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *      .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *    .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *      .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *    .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *       ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *    . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *         .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *    .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 *  Copyright FortyFix(c) 2026.
 *  Title: Richiesta Assistenza.ts;
 *  Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/environments/Modules/Klima/Richiesta Assistenza.ts;
 *  Description: ;
 *  Author: Della Porta Giovanni Battista;
 *  Created at: 29/06/26, 15:13;
 *  Updated at: 29/06/26, 15:13;
 *  ```
 */

import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {VerticalSidebarComponent} from "../../../app/layouts/vertical-sidebar/vertical-sidebar.component";
import {ApiPathsService} from "../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {HttpEventType} from "@angular/common/http";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";

const Sezioni =  [
    {
      sezione: 'LUOGO DI INTERVENTO',
      //titleClass: 'card-header',
      titleStyle: { 'font-weight': "700", 'padding': '0.8rem',  'border-left': '5px solid #1898c6', 'max-width': '71%', 'color': 'black !important' },
      campi: [
        {
          modificabile: true,
          nome: 'Attività/Ragione Sociale',
          oggetti: ['ritiro'],
          type: 'object',
          field: ['nominativo'],
          inputType: 'text',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          class: 'col-lg-12',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Referente',
          oggetti: ['ritiro'],
          type: 'object',
          field: ['referente'],
          inputType: 'text',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          class: 'col-lg-12',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Indirizzo',
          oggetti: ['ritiro'],
          type: 'object',
          field: ['indirizzo'],
          inputType: 'text',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          class: 'col-lg-12',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Citta',
          oggetti: ['ritiro'],
          type: 'object',
          field: ['citta'],
          inputType: 'text',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',

          class: 'col-lg-6',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Prov',
          oggetti: ['ritiro'],
          type: 'object',
          field: ['provincia'],
          inputType: 'text',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          class: 'col-lg-3',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'CAP',
          oggetti: ['ritiro'],
          type: 'object',
          field: ['cap'],
          inputType: 'text',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          class: 'col-lg-3',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Tel',
          oggetti: ['ritiro'],
          type: 'object',
          field: ['telefono'],
          inputType: 'text',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          class: 'col-lg-6',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Email',
          oggetti: ['ritiro'],
          type: 'object',
          field: ['email'],
          inputType: 'text',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          class: 'col-lg-5',
          /* prevDivClass: 'col-lg-12',*/
          visibleifProhibited: true,

        },

      ]
    },
    {
      sezione: 'DATI DELLA MACCHINA',
      titleStyle: { 'font-weight': "700", 'padding': '0.8rem',  'border-left': '5px solid #1898c6', 'max-width': '71%', 'color': '#1898c6' },
      campi: [
        {
          nome: 'Modello',
          url: 'https://customer.klimaitalia.it/api/prodotti/list',
          responseHasData: true,
          parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 50 }, {nome: 'tipo', value: 68}, {nome: 'prodotto', search:true}],
          prevDivClass: "col-md-12 mb-2",
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          oggetti: ['prodotto'],
          internalOutput: 'modelloObject',
          OutputField: 'prodotto',
          modificabile: true,
          inputType: 'singleDropdown',
          placeholder: 'Modello',
          inputClass:'drop-fill',
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'prodotto',
            textField: 'prodotto',
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: true,
          },
          azioni: [
         ],
          class: 'col-lg-9 mb-2 targhetta' ,
          viewInList: true,
          visibleifProhibited: true
        },
        CampoAggiuntivo.InputField("Targhetta", 'targhetta','file' ,'col-lg-3', {multipart:true} ),
        {
          modificabile: true,
          nome: 'Matricola',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          viewInList: true,
          oggetti: ['seriale'],
          inputType: 'text',
          class: 'col-lg-7',
          visibleifProhibited: true
        },

        {
          modificabile: true,
          nome: 'Brand',
          oggetti: ['brandDesc'],
          inputType: 'text',
          hideif: { fieldnotexist: 'brand', fieldNotEqual: [{ source: 'brand', value: 76 }] },
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          class: 'col-lg-12',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Brand',
          oggetti: ['brandDesc'],
          inputType: 'text',
          hideif: { fieldnotexist: 'brand', fieldNotEqual: [{ source: 'brand', value: 551 }] },
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          class: 'col-lg-12',
          visibleifProhibited: true
        },
        {
          nome: 'Fornitore',
          source: '/anagrafica/clienti/types?tipo=1',
          responseHasData: false,
          prevDivClass: "col-md-12",
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          oggetti: ['acquisto'],
          internalOutput: 'acquistoObject',
          OutputField: 'acquisto',
          modificabile: true,
          inputType: 'singleDropdown',
          inputClass: 'drop-fill',
          placeholder: 'Fornitore',
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'label',
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: true,
            isExcluded: (_settings, item)=>{return  item[_settings?.idField ?? 'id'] > 500 && item[_settings?.idField ?? 'id']<= 547}
          },
          class: 'col-lg-12 mb-2',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Rag.Soc. del fornitore',
          oggetti: ['rivenditore'],
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          inputType: 'text',
          class: 'col-lg-9 ',
          azioni: [
          ]
        },
        CampoAggiuntivo.InputField("Ricevuta", 'ricevuta','file','col-lg-3', {multipart:true} ),
        {
          nome: 'Il Guasto è',
          source: '/rma/rma/guasti',
          responseHasData: false,
          prevDivClass: "col-md-12",
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          oggetti: ['guasto'],
          internalOutput: 'guastoObject',
          OutputField: 'guasto',
          modificabile: true,
          inputType: 'singleDropdown',
          placeholder: 'Guasto',
          inputClass: 'drop-fill',
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'label',
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: true,
          },
          class: 'col-lg-12',
          visibleifProhibited: true
        },
        {
          nome: 'Guasto Segnalato:',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
          prevDivClass: 'col-md-12',
          oggetti: ['note'],
          inputType: 'text',
          hideif: { fieldNotEqual: [{ source: 'guasto', value: 101}] },
          modificabile: true,
          class: 'col-lg-12',
        },

      ]
    }

  ];



export function Richiesta_Assistenza()
{
  var OBJ: OggettoConfig = {
    Id: "richiesta_assistenza",
    asyncMap: (x, c, callback) =>{
      callback( {ritiro:{}});
    },
    customSave:(x: any, api: ApiPathsService, callback: (x) => void, bup?:any, toastrService?: ToastrService, error?: (x) => void)=>{
      x.acquirente = Object.assign({}, x.ritiro)
      function fulladdr(cliente) : string {
        return (cliente?.indirizzo? cliente.indirizzo : "") + (cliente?.citta? ("," + cliente.citta) : "") + (cliente?.provincia? ("," + cliente.provincia) : "");
      }
      if(fulladdr(x?.ritiro) != "")
        api.ClassicGet(`/maps/api/geocode/json?address=${fulladdr(x?.ritiro).split(" ").join("+")}&key=AIzaSyAtHf7gRjLvTbRzwUy4GQ-87hNa--almW0`).subscribe(response => {
          if ( response?.results?.length > 0 && response?.results[0]?.geometry?.location) {
            x.ritiro.lat = response.results[0].geometry.location.lat;
            x.ritiro.lon = response.results[0].geometry.location.lng;
            Send();
          } else {
            toastrService.warning("L'indirizzo fornito non risulta essere corretto");
            error(x);
          }
        },() => Send())
      else
        Send();
      function createWhiteImage(): Promise<File> {
        const canvas = document.createElement('canvas');
        canvas.width = 100;
        canvas.height = 100;

        const ctx = canvas.getContext('2d')!;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, 100, 100);

        return new Promise((resolve) => {
          canvas.toBlob((blob) => {
            const file = new File([blob!], 'blank.png', {
              type: 'image/png'
            });
            resolve(file);
          }, 'image/png');
        });
      }


async function   DynamicFormGetter(sezioni:any[], source: any){
  let _form: FormData = new FormData();
  sezioni.forEach(sezione => {
    _form = ApiPathsService.DynamicFormGetter(sezione.campi, source, _form);
  })

  _form.append("includereKm", (x['km'] != null && x['km'] != undefined)==true ? '1' : '0');

  _form.append('segnalazione', 'Richiesta Telefonica');
  if(x?.acquirente && Object.getOwnPropertyNames(x?.acquirente)?.length > 0)
    Object.getOwnPropertyNames(x?.acquirente).forEach(property=>{
      if(x?.acquirente[property] && typeof x?.acquirente[property] == 'string')
        _form.append(`acquirente[${property}]`, x?.acquirente[property]?.toString() ?? '');
    })
  if(x?.ritiro && Object.getOwnPropertyNames(x?.ritiro)?.length > 0)
    Object.getOwnPropertyNames(x?.ritiro).forEach(property=>{
      if(x?.ritiro[property] && (typeof x?.ritiro[property] == 'string' || typeof x?.ritiro[property] == 'number' ))
        _form.append(`ritiro[${property}]`, x?.ritiro[property]?.toString() ?? '');
    })
  if(x.photo )
    x.photo.forEach(data => {
      _form.append("photo[]", data)
    })
  if(!x.targhetta || !x.ricevuta) {
    var blank = await createWhiteImage();
    if (!x.targhetta)
      _form.append(
        'targhetta',
        blank
      );
    if (!x.ricevuta)
      _form.append(
        'ricevuta',
        blank
      );
  }
  // if(this.Targhetta)
  //   _form.append("targhetta", this.Targhetta)
  // if ( this.Ricevuta)
  //   _form.append("ricevuta", this.Ricevuta)
  return _form;
}
      async function Send() {



        const _data = await DynamicFormGetter(Sezioni, x) ;
        api.MultipartPost(_data,api.getBaseAPI()+"/rma/rma/new").subscribe((event) => {
          if (event.type === HttpEventType.UploadProgress) {

          } else if (event.type === HttpEventType.Response) {
            if (event.status === 200 || event.status === 201) {
              callback({ritiro: {}});
              toastrService.success("Richiesta creata con successo");
            }
            else {
              api.handleErrors(event)
              error(x)
            }
          }
        }, ()=>{error(x)})



      }
    },
    HasGet:false,
    RestRoute:"rma/rma",
    EditView:'Page',
    sezioni: Sezioni,
    MenuItems: [
      {
        path: "/shared/dynamicedit/richiesta_assistenza",
        title: "Nuova Richiesta Assistenza",
        icon: "fa-solid fa-people-arrows",
        class: "",
        capacita: [],
        show:(component: VerticalSidebarComponent)=>component.permission.isntOperativeRoles(['C', 'CA', 'AC']),
      },
    ]
  }
  return OBJ;
}


export var Richiesta_AssistenzaEnv = () => {
  var env: any = {
    Modules: {
      "Richiesta_Assistenza": true
    },
    Cruds: [Richiesta_Assistenza()],
    Menu: [...Richiesta_Assistenza().MenuItems]
  }
  return env;

}
